import React, { useState } from 'react'

import { Col, Row, HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import PaymentSolutions from './payment-solutions'
import SandboxPayments from './sandbox-payments'
import AppCredentials from './app-credentials'
import UpgradeAccount from './upgrade-account'
import LiveCredentialsFromClient from './live-credentials-from-client'
import CreateLiveApp from './create-live-app'
import Spinner from '../../../components/common/spinner'
import IntegrationGuide from './integration-guide'
import DoneTesting from './done-testing'
import FullAuthNeeded from '../../applications/sections/full-auth-needed'
import LiveNotAllowed from '../../applications/sections/live-not-allowed'

//eslint-disable-next-line complexity
const BannerContent = ({
  accountType,
  bannerPage,
  isCredsForClient,
  setBannerPage,
  productIntegration,
  setIsCredsForClient,
  setProductIntegration,
}) => {
  const [tabIndex, setTabIndex] = useState(0)

  const {
    sandboxApps,
    liveApps,
    homePageDataLoading,
    setCurrentBannerStep,
    isWebLLSUser,
    feature_flag,
    liveApiAllowed,
  } = useApplicationContext()

  const sbApp =
    sandboxApps?.length > 0
      ? sandboxApps.find((e) => e.isSystemGenerated === true) || sandboxApps[0]
      : null
  const liveApp = liveApps?.length > 0 ? liveApps[0] : null

  if (bannerPage === 0) {
    return (
      <PaymentSolutions
        setBannerPage={setBannerPage}
        setProductIntegration={setProductIntegration}
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        setCurrentBannerStep={setCurrentBannerStep}
      />
    )
  }

  if (bannerPage === 1) {
    return (
      <IntegrationGuide
        setBannerPage={setBannerPage}
        productIntegration={productIntegration}
      />
    )
  }

  if (bannerPage === 2) {
    return (
      <AppCredentials setBannerPage={setBannerPage} app={sbApp} env="sandbox" />
    )
  }

  if (bannerPage === 3) {
    return <SandboxPayments setBannerPage={setBannerPage} />
  }

  if (bannerPage === 4) {
    if (isWebLLSUser && accountType === 'BUSINESS') {
      return (
        <>
          <Row>
            <Col xs={10} className="banner-title_row">
              <HeadingText size="sm">
                <Message id="onboarding-banner.livePaymentsTitle" />
              </HeadingText>
            </Col>
          </Row>
          <FullAuthNeeded />
        </>
      )
    }

    if (liveApiAllowed === false && accountType === 'BUSINESS') {
      return (
        <>
          <Row>
            <Col xs={10} className="banner-title_row">
              <HeadingText size="sm">
                <Message id="onboarding-banner.livePaymentsTitle" />
              </HeadingText>
            </Col>
          </Row>
          <LiveNotAllowed />
        </>
      )
    }

    if (feature_flag === 'Trmt_developer_feature_flag') {
      return null
    }

    if (!isWebLLSUser && isCredsForClient) {
      return (
        <LiveCredentialsFromClient setIsCredsForClient={setIsCredsForClient} />
      )
    }

    if (!isWebLLSUser && !isCredsForClient && accountType === 'BUSINESS') {
      if (!liveApp) {
        if (homePageDataLoading) {
          return <Spinner size="md" />
        }

        return <CreateLiveApp setBannerPage={setBannerPage} />
      }

      return (
        <AppCredentials
          setBannerPage={setBannerPage}
          app={liveApp}
          env="live"
        />
      )
    }

    if (!isCredsForClient && accountType !== 'BUSINESS') {
      return (
        <UpgradeAccount
          setBannerPage={setBannerPage}
          setIsCredsForClient={setIsCredsForClient}
        />
      )
    }
  }

  if (bannerPage === 5) {
    return <DoneTesting />
  }

  return <></>
}

export default BannerContent
